import { without } from 'lodash';

import {
    CHANGE_ITEM_CRYPTA_SOCIAL_DEMO,
    CLOSE_CRYPTA_SOCIAL_DEMO_EDITOR,
    CryptaSocialDemoEditorAction,
    OPEN_CRYPTA_SOCIAL_DEMO_EDITOR
} from '../../actions/targetings/cryptaSocialDemo';
import { CryptaSocialDemoEditorState } from '../../typings/audienceTargetings';
import { CryptaSocialDemoEditorsState, State } from '../../typings/state';

export const defaultCryptaSocialDemoEditorsState: CryptaSocialDemoEditorState = {
    isOpen: false,
    checkedItems: []
};

export const cryptaSocialDemoEditorsInitialState: CryptaSocialDemoEditorsState = {};

export function cryptaSocialDemoEditor(
    state: CryptaSocialDemoEditorsState = cryptaSocialDemoEditorsInitialState,
    action: CryptaSocialDemoEditorAction,
    fullState: State
): CryptaSocialDemoEditorsState {
    switch (action.type) {
        case OPEN_CRYPTA_SOCIAL_DEMO_EDITOR: {
            const editor = state[action.id] || {
                ...defaultCryptaSocialDemoEditorsState
            };

            if (action.itemsId.length !== 0) {
                editor.checkedItems = action.itemsId;
            }

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    isOpen: true
                }
            };
        }

        case CHANGE_ITEM_CRYPTA_SOCIAL_DEMO: {
            const editor = state[action.id];
            const checkedItems = editor.checkedItems;
            const itemId = action.itemId;

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    checkedItems: checkedItems.includes(itemId)
                        ? without(checkedItems, itemId)
                        : checkedItems.concat(itemId)
                }
            };
        }

        case CLOSE_CRYPTA_SOCIAL_DEMO_EDITOR: {
            const editor = state[action.id];

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    checkedItems: action.itemsId || editor.checkedItems,
                    isOpen: false
                }
            };
        }

        default:
            return state;
    }
}
